module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Ka-La.bab1f090.png";